import gql from 'graphql-tag';

const ineligiblePurchasesQuery = gql`
  query IneligiblePurchases(
    $page: Int
    $limit: Int
    $categoryCode: String
    $vin: String
    $dealer: String
  ) {
    externalIneligiblePurchases(
      page: $page
      limit: $limit
      categoryCode: $categoryCode
      vin: $vin
      dealer: $dealer
    ) {
      total
      items {
        id: externalId
        externalId
        vin
        make
        model
        modelYear
        odometer
        salePrice
        auctionCode
        auctionName
        saleNumber
        saleLane
        saleRun
        purchaseDate
        ineligibilityCode
        ineligibilityReason
        ineligibilityNotice
        productCategory
        sellerNo
        buyerNo
      }
    }
  }
`;

export default ineligiblePurchasesQuery;
